import React from "react";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationDeleteMessage } from "@components/Common/ConfirmationDeleteMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import OriginHistory from "./OriginHistory";
import { MessageConfirmation } from "./MessageConfimation";
import { ConfirmationActivate } from "./ConfirmationActivate";
import { ConfirmationArchiveDesarchiveComponent } from "./ConfirmationArchiveDesarchiveComponent";
import { ConfirmationActivationDeactivationMessageModal } from "@components/Common/ConfirmationActivationDeactivationMessageModal";
import { ConfirmationFavorite } from "../ConfirmationFavorite";
import { t } from "i18next";

const VatRateModals = ({
    typeDisplay,
    isClickedModalDelete,
    setIsClickedModalDelete,
    userID,
    franchiseID,
    vatRateId,
    operatorID,
    uuidUser,
    isInInitializationModalOpened,
    setIsInInitializationModalOpened,
    isAddNewVatRateButtonClicked,
    setIsAddNewVatRateButtonClicked,
    setIsEdited,
    isAddVatRateOriginHistoryClicked,
    setIsAddVatRateOriginHistoryClicked,
    isDeleteCheckClick,
    setIsDeleteCheckClick,
    isActionsClicked,
    setIsActionsClicked,
    validationAction,
    actions,
    activationDeactivationMessageModalOpened,
    oneShop,
    isModalOpened,
    setIsModalOpened,
    vatRateData,
    isModalMessageConfirmationOpened,
    setIsModalMessageConfirmationOpened,
}: any) => {
    const apiUrl = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/general/vatRateArchivedEdit?userId=${userID}&archived=${
        typeDisplay === "notArchived"
    }&franchiseId=${franchiseID}&idVatRate=${vatRateId}&operatorId=${operatorID}&uuidUser=${uuidUser}`;

    return (
        <React.Fragment>
            <ConfirmationDeleteMessage
                isModalOpened={isClickedModalDelete}
                setIsModalOpened={setIsClickedModalDelete}
                text={
                    typeDisplay === "notArchived"
                        ? t("Please confirm deletion of this vat rate")
                        : t("Please confirm restoration of this vat rate")
                }
                message={
                    typeDisplay === "notArchived"
                        ? t("The vat rate is successfully archived")
                        : t("The vat rate is successfully restored")
                }
                apiUrl={apiUrl}
            />

            {isInInitializationModalOpened && (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewVatRateButtonClicked}
                    isClicked={isAddNewVatRateButtonClicked}
                    setIsEdited={setIsEdited}
                />
            )}

            {isAddVatRateOriginHistoryClicked && (
                <OriginHistory
                    setIsAddVatRateOriginHistoryClicked={
                        setIsAddVatRateOriginHistoryClicked
                    }
                    isAddVatRateOriginHistoryClicked={
                        isAddVatRateOriginHistoryClicked
                    }
                />
            )}

            {isDeleteCheckClick && (
                <ConfirmationArchiveDesarchiveComponent
                    setIsModalOpened={setIsDeleteCheckClick}
                    isModalOpened={isDeleteCheckClick}
                />
            )}

            {isActionsClicked && (
                <ConfirmationUpdatingDataMessageModal
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    validationAction={validationAction}
                    actions={actions}
                    setIsEdited={setIsEdited}
                />
            )}

            <ConfirmationActivate />

            <MessageConfirmation
                isModalOpened={isModalMessageConfirmationOpened}
                setIsModalOpened={setIsModalMessageConfirmationOpened}
            />

            {activationDeactivationMessageModalOpened && oneShop && (
                <ConfirmationActivationDeactivationMessageModal />
            )}

            <ConfirmationFavorite
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                e={vatRateData}
            />
        </React.Fragment>
    );
};

export default VatRateModals;
